import React from 'react';
import '../../styles/top-tabs.css';

/**
 * TopTabs Component
 * Horizontal tabs displayed at the top of the page
 * Used for navigation between different views/sections
 */
const TopTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="top-tabs-container">
      <div className="top-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`top-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TopTabs;
